import type { TaxRebate } from '../../types/tax';

export const TAX_REBATES_2026_27: TaxRebate = {
  primary: 17820,    // Under 65 years
  secondary: 9765,   // 65 years and older
  tertiary: 3249     // 75 years and older
};
